var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-field',{attrs:{"disabled":_vm.disabled,"border":false,"maxlength":"13","type":"tel","placeholder":"请输入手机号码","formatter":_vm.formatPhoneNo},model:{value:(_vm.phoneNo),callback:function ($$v) {_vm.phoneNo=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"phoneNo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }